const URI_PATH_LOCATION_SYNC = "/locationSync";
export default class LocationSyncClient {
  /**
   * Sends a new XHR POST to the locationSync path for location storage
   * @param {string} bookshareId Title instance ID
   * @param {string} newCfi New CFI locator
   * @return {Promise<JSON>} JSON response from server
   */
  async sendLocationUpdate(bookshareId, newCfi) {
    const requestBody = `bookshareId=${bookshareId}&location=${encodeURIComponent(newCfi)}`;

    var result = null;

    try {
      const response = await fetch(URI_PATH_LOCATION_SYNC, {
        method: "POST",
        body: requestBody,
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      result = await response.json();
      if (!response.ok) {
        throw new Error(result);
      }
    } catch (err) {
      console.log(`Error sending location update for location ${newCfi}`);
    }
    return result;
  }

  /**
   * Asks server for the most recent reading location
   * @param {string} bookshareId
   * @returns {Promise<JSON>} location info
   */
  async retrieveLastLocationUpdate(bookshareId) {
    try {
      // check for server location
      const requestUrl = `${URI_PATH_LOCATION_SYNC}/${bookshareId}`;
      const response = await fetch(requestUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.log(`Error retrieving last location from the server: ${error}`);
      return null;
    }
  }
}
